const driverConfig = {
  popoverClass: 'driverjs-theme',
  showButtons: ['next', 'previous', 'close'],
  nextBtnText: 'Próximo >',
  prevBtnText: '< Anterior',
  doneBtnText: 'Continuar',
  stagePadding: 12,
  showProgress: true,
  progressText: '{{current}} de {{total}}',
  allowClose: true,
  popoverOffset: 25,
  disableActiveInteraction: true,
};

export default driverConfig;
